export default () => ({
  productsCount: 0,
  products: [],
  purchase: null,
  invoices: [],
})
